import axios from 'axios';
import { clearStoredSession, getStoredToken } from './utils/auth';

let newAxios; // this will hold our configured instance

export async function createAxiosInstance() {
  const response = await fetch('/config.json');
  const configData = await response.json();

  newAxios = axios.create({
    baseURL: configData.apiBaseUrl,
    headers: {
      //"Content-Type": "application/json",
      //"Content-Type": "multipart/form-data"
    }
  });

  newAxios.interceptors.request.use((config) => {
    const token = getStoredToken();
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  });

  newAxios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401 && getStoredToken()) {
        clearStoredSession();
        window.location.href = '/';
      }

      return Promise.reject(error);
    }
  );

  return newAxios;
}

export function getAxiosInstance() {
  if (!newAxios) {
    throw new Error('Axios instance not initialized. Call createAxiosInstance() first.');
  }
  return newAxios;
}
